/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Street/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Street({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/Addresses/Content/Address/Edit/Content/Fields/Street",
  isInvalid,
  onChange,
  onChooseAddress
  
}) {
let contactMethodAssociationPostalAddressAddressLine1ValueData = fromData.useDataValue({ viewPath,
context: 'contact_method_association',
path: 'postal_address.address_line1',
})
let contactMethodAssociationPostalAddressAddressLine1IsValidData = fromData.useDataIsValid({ viewPath,
context: 'contact_method_association',
path: 'postal_address.address_line1',
validate: fromValidate.street,
required: true,
})
let contactMethodAssociationPostalAddressAddressLine1ChangeData = fromData.useDataChange({ viewPath,
context: 'contact_method_association',
path: 'postal_address.address_line1',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="contact_method_association.postal_address.address_line1"
 validate="/Data/validate.js street"
 required={true}
 invalid={!contactMethodAssociationPostalAddressAddressLine1IsValidData}
 value={contactMethodAssociationPostalAddressAddressLine1ValueData}
 onChange={contactMethodAssociationPostalAddressAddressLine1ChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Street"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 focusOnDownArrowKey={true}
 onChooseAddress={onChooseAddress}
 type="address"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}